import { Routes } from '@angular/router';
import { Home } from './pages/home/home';

export const routes: Routes = [
  { path: '', component: Home, pathMatch: 'full', title: 'Mechtron Water Services' },
  {
    path: 'equipment',
    loadChildren: () => import('./pages/equipment/equipment.routes').then(m => m.equipmentRoutes)
  },
  {
    path: 'about',
    loadComponent: () => import('./pages/about/about').then(m => m.About)
  },
  {
    path: 'contact-us',
    loadComponent: () => import('./pages/contact/contact').then(m => m.Contact)
  },
  // Legacy URL from the old app — kept so anything already indexed resolves.
  { path: 'home', redirectTo: '', pathMatch: 'full' },
  {
    path: '**',
    loadComponent: () => import('./pages/not-found/not-found').then(m => m.NotFound)
  }
];
